/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import produce from 'immer';
import Auth from '.';
import { AuthToken } from './../../graphql/types/types.d';
import { AuthErrorPayload } from './auth-models';

const initializeState = (): Auth.model.AuthReducer => ({
  loggedIn: undefined,
  loginRedirectPath: undefined,
  firstToken: undefined,
  authToken: undefined,
  timeoutTimestamp: undefined,
  remainingTime: undefined,
  loginErrors: {},
  finishedConfirmation: false,
  shouldResetClient: false,
});

export default (
  state = initializeState(),
  action: { type: string; payload: Auth.model.AuthActionsPayload },
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Auth.actionTypes.SET_USER_LOGGED_IN:
        draft.loggedIn = true;
        return draft;
      case Auth.actionTypes.SET_USER_LOGGED_OUT:
        draft.loggedIn = false;
        return draft;
      case Auth.actionTypes.SET_LOGIN_REDIRECT_PATH:
        draft.loginRedirectPath = action.payload as string | undefined;
        return draft;
      case Auth.actionTypes.SET_FIRST_TOKEN:
        draft.firstToken = action.payload as string | undefined;
        return draft;
      case Auth.actionTypes.SET_AUTH_TOKEN:
        draft.authToken = action.payload as AuthToken | undefined;
        return draft;
      case Auth.actionTypes.SET_AUTH_TOKEN_ACCEPT_TERMS:
        if (draft.authToken) {
          draft.authToken = { ...draft.authToken, terms_of_use: undefined };
        }
        return draft;
      case Auth.actionTypes.SET_TIMEOUT_TIMESTAMP:
        draft.timeoutTimestamp = action.payload as Date | undefined;
        return draft;
      case Auth.actionTypes.SET_REMAINING_TIME:
        draft.remainingTime = action.payload as number | undefined;
        return draft;
      case Auth.actionTypes.SET_LOGIN_ERROR:
        // eslint-disable-next-line no-case-declarations
        const { key, value } = action.payload as AuthErrorPayload;
        draft.loginErrors[key] = value;
        return draft;
      case Auth.actionTypes.SET_FINISHED_CONFIRMATION:
        draft.finishedConfirmation = action.payload as boolean;
        return draft;
      case Auth.actionTypes.RESET_STORE:
        draft = { ...initializeState(), shouldResetClient: true };
        return draft;
      case Auth.actionTypes.SET_SHOULD_RESET_CLIENT:
        draft.shouldResetClient = action.payload as boolean;
        return draft;
      case Auth.actionTypes.SET_LANGUAGE:
        draft.language = action.payload as string;
        return draft;
      default:
    }
  });
